<template>
    <div class="admin-site-options-form container">
        <div class="row py-5">
            <div class="col-12">
                <h1 class="pstitle">
                    <a href="/">Access Denied - Return to Home</a>
                </h1>
            </div>
        </div>
    </div>
</template>

<script>


export default {
    name: "AccessDeniedPage",
};
</script>
